// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"0f43dcdada423425fe74","453":"7bb7e679935458a98bdd"}[chunkId] + ".js";
};